export default __webpack_public_path__ + "static/media/choose2.366db2be.svg";